import { simpleObjectHash } from '@/features/shared/tools/object'

export function withCache<TArgs extends readonly unknown[], TReturn>(
  func: (...args: TArgs) => TReturn,
  options?: { cacheSize: number },
): typeof func {
  type CacheItem = {
    key: string
    value: TReturn
  }
  const cache: CacheItem[] = []

  return (...args: TArgs) => {
    // Calcule une clée pour les paramétres
    const key = simpleObjectHash(args)

    // Recherche le résultat
    let result = cache.find((item) => item.key === key)
    if (result) return result.value

    // Execute func si absent
    result = {
      key,
      value: func(...args),
    }

    //Ajoute au cache en première position
    cache.unshift(result)

    // Si nb éléments > cacheSize, retire le dernier élément
    if (options?.cacheSize && cache.length > options.cacheSize) {
      cache.pop()
    }

    return result.value
  }
}
